// Restaurant menu templates with categories and example products
export const RESTAURANT_TEMPLATES = [
  {
    id: "sushi",
    name: "Sushi / Japones",
    icon: "🍣",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Edamame", price: 4.50, description: "Vainas de soja salteadas con sal marina" },
        { name: "Gyozas de Pollo", price: 6.50, description: "6 empanadillas japonesas a la plancha" },
        { name: "Gyozas Vegetales", price: 6.00, description: "6 empanadillas vegetarianas" },
        { name: "Tempura de Verduras", price: 7.50, description: "Verduras variadas en tempura crujiente" },
        { name: "Tataki de Salmon", price: 9.00, description: "Salmon sellado con salsa ponzu" },
        { name: "Ensalada Wakame", price: 5.50, description: "Ensalada de algas con sesamo" },
        { name: "Sopa Miso", price: 4.00, description: "Sopa tradicional con tofu y algas" },
        { name: "Spring Rolls", price: 5.50, description: "4 rollitos primavera crujientes" },
      ]},
      { name: "Menus", position: 1, products: [
        { name: "Menu Kaiso", price: 18.90, description: "Sopa miso + 8 uramaki + 4 nigiri + bebida" },
        { name: "Menu Premium", price: 24.90, description: "Edamame + 12 piezas surtidas + postre + bebida" },
        { name: "Menu Para Dos", price: 34.90, description: "Gyozas + 24 piezas variadas + 2 bebidas" },
        { name: "Menu Infantil", price: 9.90, description: "4 uramaki + tempura + zumo" },
      ]},
      { name: "Bestsellers", position: 2, products: [
        { name: "Dragon Roll", price: 12.90, description: "8 piezas con tempura de langostino y aguacate" },
        { name: "Salmon Lovers", price: 11.50, description: "10 piezas variadas de salmon" },
        { name: "Rainbow Roll", price: 13.50, description: "8 piezas con pescados variados" },
        { name: "Crispy Roll", price: 10.90, description: "8 piezas empanadas y fritas" },
      ]},
      { name: "Temakis", position: 3, products: [
        { name: "Temaki Salmon", price: 6.50, description: "Cono de salmon, arroz y aguacate" },
        { name: "Temaki Atun", price: 7.00, description: "Cono de atun picante" },
        { name: "Temaki Langostino", price: 7.50, description: "Cono de langostino tempura" },
        { name: "Temaki Vegetal", price: 5.50, description: "Cono de verduras variadas" },
      ]},
      { name: "Uramakis", position: 4, products: [
        { name: "Uramaki Salmon", price: 8.50, description: "8 piezas de salmon y queso" },
        { name: "Uramaki Atun Picante", price: 9.00, description: "8 piezas con atun y sriracha" },
        { name: "Uramaki California", price: 8.00, description: "8 piezas con surimi y aguacate" },
        { name: "Uramaki Vegetal", price: 7.50, description: "8 piezas con pepino y aguacate" },
        { name: "Uramaki Tempura", price: 9.50, description: "8 piezas con langostino tempura" },
      ]},
      { name: "Bebidas", position: 5, products: [
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Coca-Cola", price: 2.50, description: "33cl" },
        { name: "Cerveza Asahi", price: 3.50, description: "33cl" },
        { name: "Te Verde", price: 2.00, description: "Caliente o frio" },
        { name: "Sake", price: 4.50, description: "Copa de sake japones" },
      ]},
      { name: "Sobremesas", position: 6, products: [
        { name: "Mochi Ice Cream", price: 4.50, description: "3 unidades de helado mochi" },
        { name: "Cheesecake Japones", price: 5.00, description: "Tarta de queso estilo japones" },
        { name: "Tempura de Platano", price: 4.00, description: "Con helado de vainilla" },
      ]},
    ]
  },
  {
    id: "hamburgueria",
    name: "Hamburgueria",
    icon: "🍔",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Nachos con Queso", price: 7.50, description: "Nachos crujientes con cheddar fundido y jalapeños" },
        { name: "Aros de Cebolla", price: 5.50, description: "Aros empanados crujientes con salsa BBQ" },
        { name: "Nuggets de Pollo", price: 6.50, description: "8 nuggets caseros con dip" },
        { name: "Alitas BBQ", price: 8.50, description: "8 alitas glaseadas con salsa BBQ" },
      ]},
      { name: "Hamburguesas Clasicas", position: 1, products: [
        { name: "Classic Burger", price: 9.90, description: "Carne 180g, lechuga, tomate, cebolla, ketchup" },
        { name: "Cheese Burger", price: 10.90, description: "Carne 180g con doble cheddar" },
        { name: "Bacon Burger", price: 11.90, description: "Carne 180g, bacon crujiente, cheddar, BBQ" },
        { name: "Double Smash", price: 13.90, description: "Doble carne smash 2x90g con cheddar" },
      ]},
      { name: "Hamburguesas Especiales", position: 2, products: [
        { name: "Trufa Burger", price: 14.90, description: "Carne 200g, queso brie, mayonesa de trufa" },
        { name: "BBQ Lovers", price: 13.50, description: "Carne 180g, aros de cebolla, bacon, BBQ ahumada" },
        { name: "Veggie Burger", price: 10.90, description: "Hamburguesa de garbanzos con guacamole" },
        { name: "Chicken Burger", price: 11.50, description: "Pechuga empanada, coleslaw, mayo chipotle" },
      ]},
      { name: "Acompanamentos", position: 3, products: [
        { name: "Patatas Fritas", price: 3.50, description: "Patatas clasicas con sal" },
        { name: "Patatas con Cheddar", price: 5.00, description: "Con cheddar fundido y bacon" },
        { name: "Ensalada Caesar", price: 6.00, description: "Lechuga, parmesano, crutones, salsa caesar" },
        { name: "Coleslaw", price: 3.00, description: "Ensalada de col cremosa" },
      ]},
      { name: "Bebidas", position: 4, products: [
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Coca-Cola", price: 2.50, description: "33cl" },
        { name: "Cerveza Artesanal", price: 4.00, description: "33cl" },
        { name: "Milkshake", price: 5.50, description: "Vainilla, chocolate o fresa" },
      ]},
      { name: "Sobremesas", position: 5, products: [
        { name: "Brownie con Helado", price: 5.50, description: "Brownie caliente con helado de vainilla" },
        { name: "Cookie XXL", price: 3.50, description: "Cookie de chocolate gigante" },
        { name: "Churros con Chocolate", price: 4.50, description: "6 churros con salsa de chocolate" },
      ]},
    ]
  },
  {
    id: "pizzaria",
    name: "Pizzaria",
    icon: "🍕",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Bruschetta Clasica", price: 5.50, description: "Pan tostado con tomate, albahaca y aceite" },
        { name: "Focaccia al Romero", price: 4.50, description: "Con aceite de oliva y sal marina" },
        { name: "Ensalada Caprese", price: 7.00, description: "Mozzarella fresca, tomate, albahaca" },
        { name: "Carpaccio de Res", price: 9.00, description: "Con rucula, parmesano y trufa" },
      ]},
      { name: "Pizzas Clasicas", position: 1, products: [
        { name: "Margherita", price: 9.50, description: "Tomate, mozzarella, albahaca fresca" },
        { name: "Pepperoni", price: 11.00, description: "Tomate, mozzarella, pepperoni picante" },
        { name: "4 Quesos", price: 12.00, description: "Mozzarella, gorgonzola, parmesano, provolone" },
        { name: "Hawaiana", price: 10.50, description: "Tomate, mozzarella, jamon, pina" },
      ]},
      { name: "Pizzas Especiales", position: 2, products: [
        { name: "Trufa e Funghi", price: 14.50, description: "Crema de trufa, champinones, mozzarella" },
        { name: "Diavola", price: 12.50, description: "Salame picante, nduja, mozzarella" },
        { name: "Burrata", price: 13.50, description: "Burrata fresca, tomate cherry, rucula" },
        { name: "Calzone", price: 12.00, description: "Relleno de jamon, ricotta y mozzarella" },
      ]},
      { name: "Pastas", position: 3, products: [
        { name: "Carbonara", price: 11.00, description: "Spaghetti con guanciale, huevo, pecorino" },
        { name: "Bolognesa", price: 10.50, description: "Tagliatelle con ragu de carne" },
        { name: "Pesto Genovese", price: 10.00, description: "Penne con pesto fresco de albahaca" },
      ]},
      { name: "Bebidas", position: 4, products: [
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Coca-Cola", price: 2.50, description: "33cl" },
        { name: "Vino Tinto Copa", price: 3.50, description: "Vino de la casa" },
        { name: "Cerveza", price: 2.50, description: "33cl" },
      ]},
      { name: "Sobremesas", position: 5, products: [
        { name: "Tiramisu", price: 5.50, description: "Clasico tiramisu italiano" },
        { name: "Panna Cotta", price: 5.00, description: "Con coulis de frutos rojos" },
      ]},
    ]
  },
  {
    id: "churrascaria",
    name: "Churrascaria / Parrilla",
    icon: "🥩",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Croquetas de Jamon", price: 6.50, description: "6 croquetas caseras de jamon iberico" },
        { name: "Tabla de Embutidos", price: 12.00, description: "Jamon, chorizo, lomo, queso manchego" },
        { name: "Pimientos de Padron", price: 5.50, description: "Con sal gruesa" },
      ]},
      { name: "Carnes a la Parrilla", position: 1, products: [
        { name: "Picanha", price: 18.90, description: "300g de picanha a la brasa" },
        { name: "Entrecot", price: 16.90, description: "350g con chimichurri" },
        { name: "Costillas BBQ", price: 15.90, description: "Rack de costillas glaseadas" },
        { name: "Pollo a la Brasa", price: 12.90, description: "Medio pollo marinado" },
        { name: "Chorizo Criollo", price: 8.50, description: "Chorizo argentino a la parrilla" },
      ]},
      { name: "Acompanamentos", position: 2, products: [
        { name: "Patatas Asadas", price: 4.00, description: "Con romero y ajo" },
        { name: "Ensalada Mixta", price: 4.50, description: "Lechuga, tomate, cebolla, maiz" },
        { name: "Arroz con Frijoles", price: 3.50, description: "Arroz y frijoles negros" },
        { name: "Farofa", price: 3.00, description: "Harina de mandioca tostada" },
      ]},
      { name: "Bebidas", position: 3, products: [
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Cerveza", price: 2.50, description: "33cl" },
        { name: "Vino Tinto Botella", price: 14.00, description: "Malbec argentino" },
        { name: "Caipirinha", price: 6.50, description: "Cachaca, lima, azucar" },
      ]},
      { name: "Sobremesas", position: 4, products: [
        { name: "Flan Casero", price: 4.50, description: "Con caramelo" },
        { name: "Helado Artesanal", price: 4.00, description: "2 bolas, sabor a elegir" },
      ]},
    ]
  },
  {
    id: "espanola",
    name: "Comida Espanola",
    icon: "🇪🇸",
    categories: [
      { name: "Tapas", position: 0, products: [
        { name: "Patatas Bravas", price: 5.50, description: "Con salsa brava y alioli" },
        { name: "Tortilla Espanola", price: 6.00, description: "De patata con cebolla" },
        { name: "Jamon Iberico", price: 14.00, description: "Racion de jamon iberico de bellota" },
        { name: "Gambas al Ajillo", price: 9.50, description: "Gambas salteadas con ajo y guindilla" },
        { name: "Croquetas Caseras", price: 6.50, description: "6 unidades de jamon" },
        { name: "Calamares a la Romana", price: 8.00, description: "Con limon y alioli" },
      ]},
      { name: "Principales", position: 1, products: [
        { name: "Paella Mixta", price: 14.90, description: "Arroz con mariscos y pollo" },
        { name: "Pulpo a la Gallega", price: 16.00, description: "Con patata y pimenton" },
        { name: "Merluza a la Vasca", price: 15.50, description: "Con salsa verde y almejas" },
        { name: "Cochinillo Asado", price: 18.00, description: "Cochinillo al horno de lena" },
      ]},
      { name: "Bebidas", position: 2, products: [
        { name: "Tinto de Verano", price: 3.00, description: "Vino con limon" },
        { name: "Sangria Jarra", price: 12.00, description: "1 litro" },
        { name: "Cerveza Cana", price: 2.00, description: "20cl" },
        { name: "Agua", price: 1.50, description: "50cl" },
      ]},
      { name: "Sobremesas", position: 3, products: [
        { name: "Crema Catalana", price: 5.00, description: "Clasica con azucar quemado" },
        { name: "Tarta de Santiago", price: 5.50, description: "Tarta de almendras gallega" },
      ]},
    ]
  },
  {
    id: "portuguesa",
    name: "Comida Portuguesa",
    icon: "🇵🇹",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Pasteis de Bacalhau", price: 7.00, description: "6 bolinhos de bacalao tradicionales" },
        { name: "Alheira Frita", price: 6.50, description: "Con huevo frito y ensalada" },
        { name: "Chourico Flameado", price: 8.00, description: "Chourico asado en la mesa" },
        { name: "Sopa de Legumes", price: 3.50, description: "Sopa tradicional portuguesa" },
      ]},
      { name: "Principales", position: 1, products: [
        { name: "Bacalhau a Bras", price: 14.50, description: "Bacalao desmenuzado con patatas y huevo" },
        { name: "Francesinha", price: 13.00, description: "Sandwich clasico de Porto con salsa" },
        { name: "Arroz de Marisco", price: 22.00, description: "Para 2 personas" },
        { name: "Leitao da Bairrada", price: 16.00, description: "Cochinillo asado estilo Bairrada" },
        { name: "Polvo a Lagareiro", price: 18.00, description: "Pulpo al horno con patatas" },
      ]},
      { name: "Bebidas", position: 2, products: [
        { name: "Vinho Verde", price: 3.50, description: "Copa de vino verde" },
        { name: "Super Bock", price: 2.50, description: "33cl" },
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Ginjinha", price: 3.00, description: "Licor de guinda" },
      ]},
      { name: "Sobremesas", position: 3, products: [
        { name: "Pastel de Nata", price: 2.50, description: "Pastel de Belem clasico" },
        { name: "Pudim Flan", price: 4.00, description: "Flan portugues con caramelo" },
        { name: "Arroz Doce", price: 3.50, description: "Arroz con leche y canela" },
      ]},
    ]
  },
  {
    id: "mexicana",
    name: "Comida Mexicana",
    icon: "🌮",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Nachos Supreme", price: 8.00, description: "Con cheddar, guacamole, pico de gallo, crema" },
        { name: "Guacamole Fresco", price: 6.50, description: "Con totopos caseros" },
        { name: "Elote Callejero", price: 4.50, description: "Maiz con mayo, chile y limon" },
      ]},
      { name: "Tacos", position: 1, products: [
        { name: "Tacos al Pastor", price: 9.50, description: "3 tacos de cerdo marinado con pina" },
        { name: "Tacos de Carnitas", price: 9.50, description: "3 tacos de cerdo confitado" },
        { name: "Tacos de Pollo", price: 8.50, description: "3 tacos de pollo a la plancha" },
        { name: "Tacos de Pescado", price: 10.00, description: "3 tacos de pescado empanado" },
      ]},
      { name: "Burritos", position: 2, products: [
        { name: "Burrito de Carne", price: 10.50, description: "Carne, arroz, frijoles, queso, pico de gallo" },
        { name: "Burrito Vegetal", price: 9.00, description: "Verduras, arroz, frijoles, guacamole" },
        { name: "Bowl Mexicano", price: 10.00, description: "Sin tortilla, con todos los ingredientes" },
      ]},
      { name: "Bebidas", position: 3, products: [
        { name: "Margarita", price: 7.00, description: "Clasica o de fresa" },
        { name: "Agua de Jamaica", price: 3.00, description: "Infusion de hibisco" },
        { name: "Corona", price: 3.50, description: "33cl" },
        { name: "Agua", price: 1.50, description: "50cl" },
      ]},
      { name: "Sobremesas", position: 5, products: [
        { name: "Churros con Chocolate", price: 5.00, description: "6 churros con salsa de chocolate" },
        { name: "Tres Leches", price: 5.50, description: "Bizcocho empapado en tres leches" },
      ]},
    ]
  },
  {
    id: "italiana",
    name: "Restaurante Italiano",
    icon: "🇮🇹",
    categories: [
      { name: "Antipasti", position: 0, products: [
        { name: "Carpaccio de Res", price: 10.00, description: "Con rucula y parmesano" },
        { name: "Burrata", price: 9.00, description: "Con tomate cherry y pesto" },
        { name: "Vitello Tonnato", price: 10.50, description: "Ternera con salsa de atun" },
      ]},
      { name: "Pastas", position: 1, products: [
        { name: "Carbonara", price: 12.00, description: "Spaghetti con guanciale y pecorino" },
        { name: "Cacio e Pepe", price: 11.00, description: "Tonnarelli con pecorino y pimienta" },
        { name: "Ragu alla Bolognese", price: 12.50, description: "Tagliatelle con ragu de carne" },
        { name: "Amatriciana", price: 11.50, description: "Bucatini con tomate y guanciale" },
      ]},
      { name: "Secondi", position: 2, products: [
        { name: "Ossobuco", price: 18.00, description: "Jarrete de ternera con risotto" },
        { name: "Saltimbocca", price: 16.00, description: "Ternera con jamon y salvia" },
        { name: "Risotto ai Funghi", price: 14.00, description: "Con champinones porcini" },
      ]},
      { name: "Dolci", position: 3, products: [
        { name: "Tiramisu", price: 6.00, description: "Clasico" },
        { name: "Panna Cotta", price: 5.50, description: "Con frutos rojos" },
        { name: "Cannoli Siciliani", price: 5.00, description: "2 unidades con ricotta" },
      ]},
      { name: "Bebidas", position: 4, products: [
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Prosecco Copa", price: 5.00, description: "" },
        { name: "Chianti Copa", price: 4.50, description: "" },
        { name: "Espresso", price: 1.80, description: "" },
      ]},
    ]
  },
  {
    id: "cafeteria",
    name: "Cafeteria / Bakery",
    icon: "☕",
    categories: [
      { name: "Cafes", position: 0, products: [
        { name: "Espresso", price: 1.50, description: "" },
        { name: "Americano", price: 2.00, description: "" },
        { name: "Cappuccino", price: 2.80, description: "" },
        { name: "Latte", price: 3.00, description: "Con leche de avena disponible" },
        { name: "Flat White", price: 3.20, description: "" },
      ]},
      { name: "Desayunos", position: 1, products: [
        { name: "Tostada con Tomate", price: 3.50, description: "Pan con tomate y aceite" },
        { name: "Tostada con Aguacate", price: 5.50, description: "Con huevo pochado" },
        { name: "Croissant", price: 2.50, description: "Mantequilla francesa" },
        { name: "Pancakes", price: 7.00, description: "Con sirope y frutos rojos" },
        { name: "Acai Bowl", price: 8.00, description: "Con granola y frutas frescas" },
      ]},
      { name: "Sandwiches", position: 2, products: [
        { name: "Club Sandwich", price: 7.50, description: "Pollo, bacon, lechuga, tomate" },
        { name: "Veggie Wrap", price: 6.50, description: "Hummus, verduras asadas" },
        { name: "Tuna Melt", price: 7.00, description: "Atun con cheddar fundido" },
      ]},
      { name: "Bolleria", position: 3, products: [
        { name: "Croissant de Chocolate", price: 3.00, description: "" },
        { name: "Muffin", price: 2.80, description: "Arandanos o chocolate" },
        { name: "Cookie", price: 2.50, description: "Chocolate chip" },
        { name: "Tarta del Dia", price: 4.50, description: "Consultar" },
      ]},
      { name: "Bebidas Frias", position: 4, products: [
        { name: "Zumo Natural", price: 3.50, description: "Naranja o mixto" },
        { name: "Smoothie", price: 5.00, description: "Frutas del dia" },
        { name: "Ice Latte", price: 3.50, description: "" },
        { name: "Limonada", price: 3.00, description: "Casera con menta" },
      ]},
    ]
  },
  {
    id: "china",
    name: "Comida China",
    icon: "🥡",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Rollitos de Primavera", price: 5.00, description: "4 rollitos vegetales crujientes" },
        { name: "Wan Tan Frito", price: 5.50, description: "8 wan tans crujientes" },
        { name: "Sopa Wan Tan", price: 4.50, description: "Caldo con wan tans de cerdo" },
        { name: "Dim Sum Variado", price: 8.00, description: "6 piezas al vapor" },
      ]},
      { name: "Arroces", position: 1, products: [
        { name: "Arroz 3 Delicias", price: 7.50, description: "Con jamon, huevo y verduras" },
        { name: "Arroz con Pollo", price: 8.50, description: "Salteado con salsa de soja" },
        { name: "Arroz con Gambas", price: 9.50, description: "Con gambas y verduras" },
      ]},
      { name: "Fideos", position: 2, products: [
        { name: "Fideos Salteados", price: 8.00, description: "Con verduras y pollo" },
        { name: "Chow Mein", price: 8.50, description: "Fideos crujientes con ternera" },
        { name: "Pad Thai", price: 9.00, description: "Estilo thai con cacahuetes" },
      ]},
      { name: "Platos Principales", position: 3, products: [
        { name: "Pollo Agridulce", price: 9.50, description: "Clasico con pina y pimiento" },
        { name: "Cerdo Char Siu", price: 10.50, description: "Cerdo glaseado barbacoa" },
        { name: "Ternera con Brocoli", price: 10.00, description: "Salteado con salsa de ostras" },
        { name: "Pato Pekin", price: 16.00, description: "Con tortillas y salsa hoisin" },
      ]},
      { name: "Bebidas", position: 4, products: [
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Cerveza Tsingtao", price: 3.00, description: "33cl" },
        { name: "Te Jasmin", price: 2.00, description: "" },
      ]},
    ]
  },
  {
    id: "india",
    name: "Comida India",
    icon: "🍛",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Samosas", price: 5.50, description: "3 empanadillas de patata y guisantes" },
        { name: "Pakoras", price: 5.00, description: "Verduras en masa especiada" },
        { name: "Naan Bread", price: 3.00, description: "Pan tradicional del tandoor" },
      ]},
      { name: "Curries", position: 1, products: [
        { name: "Butter Chicken", price: 12.00, description: "Pollo en salsa cremosa de tomate" },
        { name: "Tikka Masala", price: 12.50, description: "Pollo tandoori en salsa masala" },
        { name: "Lamb Rogan Josh", price: 14.00, description: "Cordero en salsa de especias kashmiri" },
        { name: "Chana Masala", price: 9.50, description: "Garbanzos en salsa especiada (vegano)" },
        { name: "Palak Paneer", price: 10.00, description: "Espinacas con queso paneer" },
      ]},
      { name: "Tandoori", position: 2, products: [
        { name: "Tandoori Chicken", price: 11.00, description: "Medio pollo marinado al tandoor" },
        { name: "Seekh Kebab", price: 10.00, description: "Brochetas de carne especiada" },
      ]},
      { name: "Acompanamentos", position: 3, products: [
        { name: "Arroz Basmati", price: 3.00, description: "" },
        { name: "Garlic Naan", price: 3.50, description: "Pan con ajo" },
        { name: "Raita", price: 2.00, description: "Yogur con pepino y menta" },
      ]},
      { name: "Bebidas", position: 4, products: [
        { name: "Mango Lassi", price: 3.50, description: "Bebida de yogur con mango" },
        { name: "Chai Tea", price: 2.50, description: "Te con especias y leche" },
        { name: "Agua", price: 1.50, description: "50cl" },
      ]},
    ]
  },
  {
    id: "thai",
    name: "Comida Thai",
    icon: "🇹🇭",
    categories: [
      { name: "Entradas", position: 0, products: [
        { name: "Tom Yum", price: 6.50, description: "Sopa picante con gambas" },
        { name: "Satay de Pollo", price: 7.00, description: "Brochetas con salsa de cacahuete" },
        { name: "Spring Rolls", price: 5.50, description: "Rollitos frescos con salsa dulce" },
      ]},
      { name: "Curry", position: 1, products: [
        { name: "Green Curry", price: 11.50, description: "Curry verde con pollo y albahaca thai" },
        { name: "Red Curry", price: 11.50, description: "Curry rojo con gambas" },
        { name: "Massaman Curry", price: 12.00, description: "Curry con ternera y cacahuetes" },
      ]},
      { name: "Wok", position: 2, products: [
        { name: "Pad Thai", price: 10.50, description: "Fideos de arroz con gambas y cacahuetes" },
        { name: "Pad See Ew", price: 9.50, description: "Fideos anchos con pollo y brocoli" },
        { name: "Basil Chicken", price: 10.00, description: "Pollo salteado con albahaca thai" },
      ]},
      { name: "Bebidas", position: 3, products: [
        { name: "Thai Iced Tea", price: 3.50, description: "Te con leche condensada" },
        { name: "Agua de Coco", price: 3.00, description: "Natural" },
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Cerveza Chang", price: 3.00, description: "33cl" },
      ]},
    ]
  },
  {
    id: "kebab",
    name: "Kebab / Doner",
    icon: "🥙",
    categories: [
      { name: "Kebabs", position: 0, products: [
        { name: "Doner Kebab", price: 6.50, description: "Pan de pita con carne doner, ensalada y salsa" },
        { name: "Durum", price: 7.00, description: "Wrap grande con carne doner" },
        { name: "Plato Kebab", price: 9.00, description: "Con arroz, ensalada y salsas" },
        { name: "Falafel Wrap", price: 6.00, description: "Con hummus, ensalada y tahini" },
      ]},
      { name: "Hamburguesas", position: 1, products: [
        { name: "Kebab Burger", price: 7.50, description: "Carne de kebab con queso fundido" },
        { name: "Chicken Burger", price: 7.00, description: "Pechuga a la plancha" },
      ]},
      { name: "Acompanamentos", position: 2, products: [
        { name: "Patatas Fritas", price: 3.00, description: "Con sal" },
        { name: "Patatas con Queso", price: 4.50, description: "Con cheddar y salsa kebab" },
        { name: "Hummus", price: 4.00, description: "Con pan de pita" },
      ]},
      { name: "Bebidas", position: 3, products: [
        { name: "Ayran", price: 2.00, description: "Bebida de yogur salada" },
        { name: "Agua", price: 1.50, description: "50cl" },
        { name: "Coca-Cola", price: 2.50, description: "33cl" },
      ]},
    ]
  },
  {
    id: "poke",
    name: "Poke / Bowls",
    icon: "🥗",
    categories: [
      { name: "Poke Bowls", position: 0, products: [
        { name: "Salmon Poke", price: 11.50, description: "Salmon, arroz, aguacate, edamame, mango" },
        { name: "Atun Poke", price: 12.00, description: "Atun, arroz, pepino, wakame, sesamo" },
        { name: "Chicken Poke", price: 10.50, description: "Pollo teriyaki, arroz, aguacate, maiz" },
        { name: "Veggie Poke", price: 9.50, description: "Tofu, quinoa, aguacate, edamame, zanahoria" },
      ]},
      { name: "Acai Bowls", position: 1, products: [
        { name: "Acai Classic", price: 8.50, description: "Acai, granola, platano, frutos rojos" },
        { name: "Acai Tropical", price: 9.00, description: "Acai, mango, coco, pistacho" },
      ]},
      { name: "Extras", position: 2, products: [
        { name: "Extra Salmon", price: 2.50, description: "" },
        { name: "Extra Aguacate", price: 1.50, description: "" },
        { name: "Gyozas", price: 5.50, description: "6 unidades" },
      ]},
      { name: "Bebidas", position: 3, products: [
        { name: "Kombucha", price: 3.50, description: "Varios sabores" },
        { name: "Zumo Verde", price: 4.00, description: "Espinaca, manzana, jengibre" },
        { name: "Agua", price: 1.50, description: "50cl" },
      ]},
    ]
  },
  {
    id: "tapas",
    name: "Bar de Tapas",
    icon: "🍷",
    categories: [
      { name: "Tapas Frias", position: 0, products: [
        { name: "Aceitunas Aliñadas", price: 3.00, description: "Mezcla de aceitunas marinadas" },
        { name: "Jamon Iberico", price: 14.00, description: "Racion de 100g" },
        { name: "Queso Manchego", price: 7.00, description: "Con membrillo" },
        { name: "Ensaladilla Rusa", price: 5.00, description: "Con atun y mayonesa casera" },
      ]},
      { name: "Tapas Calientes", position: 1, products: [
        { name: "Patatas Bravas", price: 5.50, description: "Con brava y alioli" },
        { name: "Gambas al Ajillo", price: 9.50, description: "Con ajo y guindilla" },
        { name: "Croquetas de Jamon", price: 6.50, description: "6 unidades" },
        { name: "Pimientos de Padron", price: 5.00, description: "Con sal gruesa" },
        { name: "Pulpo a la Gallega", price: 12.00, description: "Con patata y pimenton" },
      ]},
      { name: "Raciones", position: 2, products: [
        { name: "Tabla Iberica", price: 18.00, description: "Jamon, lomo, chorizo, queso" },
        { name: "Pescadito Frito", price: 10.00, description: "Boquerones, calamares, chopitos" },
      ]},
      { name: "Vinos y Bebidas", position: 3, products: [
        { name: "Vino Tinto Copa", price: 3.00, description: "De la casa" },
        { name: "Cerveza Cana", price: 2.00, description: "20cl" },
        { name: "Vermut", price: 3.00, description: "Con aceituna y naranja" },
        { name: "Sangria Jarra", price: 12.00, description: "1 litro" },
      ]},
    ]
  },
];
